var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiToken = function SvgApiToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.5 14H5.933c-1.026 0-1.54 0-1.932-.2A1.83 1.83 0 0 1 3.2 13c-.2-.392-.2-.906-.2-1.932V5.933c0-1.026 0-1.54.2-1.932.176-.345.456-.625.801-.801.392-.2.906-.2 1.932-.2h5.134c1.026 0 1.54 0 1.932.2.345.176.625.456.801.801.2.392.2.906.2 1.932V8.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#api-token_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M14.667 12a.665.665 0 0 0-.667-.667M14 14a2 2 0 1 0-1.982-1.731c.02.145.03.217.023.263a.3.3 0 0 1-.04.115c-.022.04-.062.08-.141.16l-1.704 1.704c-.057.057-.086.086-.107.12a.3.3 0 0 0-.04.096c-.009.038-.009.08-.009.16v.58c0 .186 0 .28.036.351a.33.33 0 0 0 .146.146c.071.036.165.036.351.036h.8v-.667H12v-.666h.667l.526-.527c.08-.08.12-.119.16-.142a.3.3 0 0 1 .115-.039c.046-.006.118.004.263.023Q13.863 14 14 14"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.667 10.25 1.75-1.75-1.75-1.75m-2.334 0L5.583 8.5l1.75 1.75"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "api-token_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9h8v8H9z"
  })))));
};
export default SvgApiToken;